import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MyShifts from './components/employee/MyShifts';
import Reports from './components/admin/Reports';
import Login from './components/auth/Login';
import AuthCallback from './components/auth/AuthCallback';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PublicSchedule from './components/PublicSchedule';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './styles/main.css'; // Import the main CSS file
import './styles/custom.css'; // Import our custom overrides AFTER main.css

const App: React.FC = () => {
  // Read the environment variables here
  const employeeAppUrl = process.env.REACT_APP_EMPLOYEE_URL || "/myshifts";
  const boardAppUrl = process.env.REACT_APP_BOARD_URL || "#"; // Read board URL, default to #
  const eventsAppUrl = process.env.REACT_APP_EVENTS_URL || "#"; // Read events URL, default to #
  const lessonsAppUrl = process.env.REACT_APP_LESSONS_URL || "#"; // Read lessons URL, default to #

  return (
    <div className="app-container w-full">
      <AuthProvider>
        <Router>
          {/* Navbar now reads URLs from environment variables directly */}
          <Navbar />
          <main className="content-container">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/callback" element={<AuthCallback />} />
              <Route path="/public-schedule" element={<PublicSchedule />} />
              <Route path="/myshifts" element={
                <ProtectedRoute>
                  <MyShifts />
                </ProtectedRoute>
              } />
              <Route path="/reports" element={
                <ProtectedRoute requireAdmin>
                  <Reports />
                </ProtectedRoute>
              } />
              <Route path="/" element={<Navigate to="/myshifts" />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </AuthProvider>
    </div>
  );
};

export default App; 